import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  padding: ${spacing(1.5)}; // 12px
`
